import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import logoBlanco from '../../../images/logoBlanco.png';
import selloEfr from '../../../images/SOLIMAT sello efr_ color.jpg';
import selloAenorIso9001 from '../../../images/SelloAENORISO9001_NEG.jpg';
import wcagIcon from '../../../images/wcag2.1AA.png';
import { isExternalHttpLink, isInternalRoute } from '../../../utils/linkType';
import Container from '../Container';
import styles from './Footer.module.css';

interface FooterLinkItem {
  label: string;
  href: string;
}

const TE_PUEDE_INTERESAR: FooterLinkItem[] = [
  { label: 'Perfil del Contratante', href: '/perfil-del-contratante' },
  { label: 'Portal de Transparencia', href: 'https://transparencia.solimat.com/web/index.html' },
  { label: 'Reclamaciones y quejas', href: '/oficina-virtual-de-reclamaciones' },
  { label: 'Recursos y Herramientas', href: '/recursos-y-herramientas' },
  { label: 'Preguntas Frecuentes', href: '/preguntas-frecuentes' },
];

const ENLACES_DE_INTERES: FooterLinkItem[] = [
  { label: 'Referencias legislativas', href: '/referencias-legislativas' },
  { label: 'BOE', href: 'https://www.boe.es/' },
  { label: 'INSST', href: 'https://www.insst.es/' },
  { label: 'AMAT', href: 'https://www.amat.es/' },
  { label: 'Seguridad Social', href: 'https://www.seg-social.es/' },
];

const LEGAL_LINKS: FooterLinkItem[] = [
  { label: 'Aviso legal', href: '/aviso-legal' },
  { label: 'Política de privacidad', href: '/politica-de-privacidad' },
  { label: 'Política de cookies', href: '/politica-de-cookies' },
  //TODO: Descomentar cuando esté disponible la nueva web de gestión de contenidos
  //{ label: 'Gestor de Contenidos', href: 'https://jolly-meadow-052032703.5.azurestaticapps.net' },
];

const SOCIAL_LINKS = [
  {
    label: 'LinkedIn',
    href: 'https://es.linkedin.com/company/solimat-matepss-',
    path: 'M4.98 3.5A2.5 2.5 0 002.5 6a2.5 2.5 0 005 0 2.5 2.5 0 00-2.52-2.5zM3 8.98h4v12H3zM9.5 8.98h3.8v1.64h.05c.53-.95 1.83-1.96 3.77-1.96 4.03 0 4.78 2.65 4.78 6.1v6.22h-4v-5.51c0-1.32-.02-3-1.84-3-1.85 0-2.13 1.44-2.13 2.92v5.59h-4z',
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/user/Solimat72',
    path: 'M23 12s0-3.2-.4-4.7a2.5 2.5 0 00-1.77-1.77C19.34 5.1 12 5.1 12 5.1s-7.34 0-8.83.43A2.5 2.5 0 001.4 7.3C1 8.8 1 12 1 12s0 3.2.4 4.7a2.5 2.5 0 001.77 1.77c1.49.43 8.83.43 8.83.43s7.34 0 8.83-.43a2.5 2.5 0 001.77-1.77C23 15.2 23 12 23 12zM9.75 15.5v-7l6 3.5z',
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=100083202458773',
    path: 'M22 12a10 10 0 10-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0022 12z',
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/solimat72/',
    path: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.332.014 7.052.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z',
  },
  {
    label: 'X',
    href: 'https://x.com/Solimat72',
    path: 'M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z',
  },
];

function FooterLink({ label, href, className }: FooterLinkItem & { className?: string }): ReactNode {
  if (isInternalRoute(href)) {
    return (
      <Link className={className} to={href}>
        {label}
      </Link>
    );
  }

  if (isExternalHttpLink(href)) {
    return (
      <a className={className} href={href} target="_blank" rel="noopener noreferrer">
        {label}
      </a>
    );
  }

  return (
    <a className={className} href={href}>
      {label}
    </a>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <Container className={styles.top}>
        <div className={styles.grid}>
          <div>
            <img className={styles.brandLogo} src={logoBlanco} alt="Solimat" />
            <p className={styles.tagline}>Salud · Experiencia · Compromiso · Integridad · Confianza</p>
            <div className={styles.socials}>
              {SOCIAL_LINKS.map((social) => (
                <a
                  key={social.label}
                  className={styles.socialLink}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                >
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d={social.path} />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className={styles.heading}>Te puede interesar</div>
            <ul className={styles.linkList}>
              {TE_PUEDE_INTERESAR.map((item) => (
                <li key={item.label}>
                  <FooterLink {...item} className={styles.link} />
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className={styles.heading}>Enlaces de interés</div>
            <ul className={styles.linkList}>
              {ENLACES_DE_INTERES.map((item) => (
                <li key={item.label}>
                  <FooterLink {...item} className={styles.link} />
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className={styles.heading}>Contacto</div>
            <div className={styles.contact}>
              <div className={styles.contactName}>Sede Central</div>
              <div>C/ Berna, 1 — 4ª planta</div>
              <div>45003 Toledo</div>
              <a className={styles.contactPhone} href="tel:925283186">
                925 28 31 86
              </a>
              <div className={styles.contactEmail}>web@solimat.com</div>
              <div>
                <FooterLink
                  label="Direcciones provinciales →"
                  href="/direcciones-provinciales"
                  className={styles.contactMore}
                />
              </div>
            </div>
          </div>

          {/* Certificaciones de la mutua. Son JPG con fondo blanco, así que cada
              sello va sobre su propia ficha blanca para que no se vea un
              rectángulo suelto en el fondo oscuro. Están bajo el pliegue de todas
              las páginas: `loading="lazy"` evita descargarlos hasta que hacen falta. */}
          <div className={styles.seals}>
            <div className={styles.seal}>
              <img
                className={styles.sealImage}
                src={selloAenorIso9001}
                width="904"
                height="764"
                loading="lazy"
                decoding="async"
                alt="Certificado AENOR de Gestión de la Calidad, ISO 9001"
              />
            </div>
            <div className={styles.seal}>
              <img
                className={styles.sealImage}
                src={selloEfr}
                width="998"
                height="752"
                loading="lazy"
                decoding="async"
                alt="Certificado efr en conciliación 1000-2, ES-208/2015, AENOR"
              />
            </div>
          </div>
        </div>
      </Container>

      <div className={styles.bottom}>
        <Container className={styles.bottomBar}>
          <span>© {year} Solimat — Mutua Colaboradora con la Seguridad Social Nº 72</span>
          <div className={styles.legalLinks}>
            {/* La declaración de accesibilidad va con el sello WCAG AA, como exige el RD 1112/2018. */}
            <Link className={`${styles.legalLink} ${styles.accessibilityLink}`} to="/declaracion-de-accesibilidad">
              <img
                className={styles.wcagBadge}
                src={wcagIcon}
                width="66"
                height="24"
                alt="Icono de conformidad con el Nivel Doble-A de las Directrices de Accesibilidad para el Contenido Web 2.1 del W3C-WAI"
              />
              Accesibilidad y usabilidad
            </Link>
            {LEGAL_LINKS.map((item) => (
              // Vía FooterLink: los que ya tienen página propia (p. ej. /aviso-legal)
              // navegan con el router en vez de recargar toda la aplicación.
              <FooterLink key={item.label} {...item} className={styles.legalLink} />
            ))}
          </div>
        </Container>
      </div>
    </footer>
  );
}
